import { useIntl } from 'react-intl';
import { BaseGlobalReportPage } from '../../../common/GlobalReportPage';
import { GipReportPreviewView } from './GipReportPreviewView';

export function GipReportPreviewPage() {
  const { $t } = useIntl();

  return (
    <BaseGlobalReportPage
      title={$t({
        id: 'audit.globalReports.title',
        defaultMessage: 'Audit global',
      })}
    >
      <GipReportPreviewView />
    </BaseGlobalReportPage>
  );
}
